// extracted by mini-css-extract-plugin
export default {"AdminMenu":"adminMenu_AdminMenu__4wHHg"};